export const POI_METHOD = {
  STATIC: "11",
  DYNAMIC: "12",
} as const;
